import styled from "styled-components";

export const PageHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PageHeaderTitle = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.deepDark};

  @media (max-width: ${({ theme }) => theme.breakpoints.m}) {
    font-size: 18px;
  }
`;

export const PageHeaderSubtitle = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: ${({ theme }) => theme.colors.mediumDark};
  margin-top: 4px;

  @media (max-width: ${({ theme }) => theme.breakpoints.m}) {
    font-size: 14px;
  }
`;
